module.exports = __webpack_public_path__ + "media/src/images/speech-bubble-3c9bc97153a4ba67e118b2d5e80febd2.svg";